"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsValidForm = void 0;
const hasError = (item) => item;
const getIsValidForm = (internalErrors, schemaErrors) => !(Object.values(schemaErrors).some(hasError) || Object.values(internalErrors).some(hasError));
exports.getIsValidForm = getIsValidForm;
//# sourceMappingURL=getIsValidForm.js.map